// First param is UTC ISO string. If string contains offset or Z,
// it will first be translated to the timezone of tzFrom param.
//
// Thus, if you are wanting to convert from America/New_York
// to UTC, and you pass in a iso string with a Z,
// you will get back the same string, because
// utc => ny => utc
//
// If you want to actually go from America/New_York to UTC,
// strip off the utc offset (or z) in this case, to avoid first
// translation.

import { DateTime } from "luxon";

export default (
  str, // iso string
  tzFrom = "UTC",
  tzTo = "America/New_York",
  format = "TIME_SIMPLE", // 1:30 PM; TIME_24_SIMPLE: 13:30
) => {
  const isISOTime = String(str).match(/^(?:2[0-3]|[01][0-9]):[0-5][0-9](:[0-5][0-9])?$/g);
  const isISODate = String(str).match(
    /^[0-9]{4}-[0-9]{2}-[0-9]{2}T(?:2[0-3]|[01][0-9]):[0-5][0-9](:[0-5][0-9](.?[0-9]{6})?)?/g,
  );
  const now = DateTime.now();
  let dateFrom = null;
  if (isISOTime) dateFrom = DateTime.fromISO(`${now.toISODate()}T${str}`, { zone: tzFrom });
  if (isISODate) dateFrom = DateTime.fromISO(str, { zone: tzFrom });
  if (!dateFrom) return "";
  const dateTo = dateFrom.setZone(tzTo);
  if (format === "ISO") return dateTo.toISO();
  return dateTo.toLocaleString(DateTime[format]);
};
